/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useEffect, useMemo, useState} from "react";
import MapBase from "./MapBase";
import {MapPropsProvider} from "./MapPropsContext";
import useMapProps from "./useMapProps";
import {getListByParameters} from "../../api";
import WidgetContainer from "./widgets/WidgetContainer";
import WidgetImpCheckFilter from "./widgets/WidgetImpCheckFilter";
import {Button, Drawer, Table, Tabs, Alert, Icon, message, Tooltip} from "antd";
import Axios from "axios";
import {
  getApiHost,
  getApiUrl,
  getLastDomByClassName,
  makeTableSorterFn,
  msgClose,
  positionToDegress,
  degressToPosition,
  makeTableSorterFnNumber,
  formatUid, getReadableFreq
} from "../../utils";


import WidgetImpCheck from "./widgets/WidgetImpCheck";
import WidgetImpCheckSensitivity from "./widgets/WidgetImpCheckSensitivity";
import WidgetLegend from "./widgets/WidgetLegend";
import WidgetUidWithShortcut from "./widgets/WidgetUidWithShortcut";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
import WidgetToolbar from "./widgets/WidgetToolbar";
import usePortal from "react-useportal";
import AlignRightText from "./widgets/AlignRightText";
import AlignCenterText from "./widgets/AlignCenterText";
import AlignCenterText2 from "./widgets/AlignCenterText2";
import EllipsisText from "./widgets/EllipsisText";
import usePromise from "../../utils/hooks/usePromise";
import LoadingIndicator from "../../components/LoadingIndicator";
import ExportExcelButton from "../../utils/export";
import {WELL_KNOWN_POSITION} from "../../Constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel} from "@fortawesome/free-solid-svg-icons";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import {PALETTE_YlOrRd_9, TRANSPARENT_COLOR} from "../../utils/Palette";
import {arrayToRgb,numberWithCommas} from "../../utils";
import WidgetGeocoding from "./widgets/WidgetGeocoding";


const INITIAL_VIEW_STATE = {
  ...WELL_KNOWN_POSITION.광주광역시,
  zoom: 8,
};


const ICON_LEGEND = [
  ['national-blue', `매우 높음( -60 ~ ${-60 - Math.abs(130 - 60) / 5})`],
  ['national-green', `높음(${-60 - Math.abs(130 - 60) / 5} ~ ${-60 - Math.abs(130 - 60) / 5 * 2})`],
  ['national-yellow', `보통(${-60 - Math.abs(130 - 60) / 5 * 2} ~ ${-60 - Math.abs(130 - 60) / 5 * 3})`],
  ['national-orange', `낮음(${-60 - Math.abs(130 - 60) / 5 * 3} ~ ${-60 - Math.abs(130 - 60) / 5 * 4})`],
  ['national-red', `매우 낮음(${-60 - Math.abs(130 - 60) / 5 * 4} ~)`],
];

message.config({
  top: 250,
  duration: 5,
  maxCount: 1,
});

//const infoByExtraSearchOfBukhansan = () => {
//  message.info({
//    content: <span style={{fontSize:15}}> 북한산은 "경계확장검색(3km)"을 지원하지 않습니다.</span>,
//  });
//};


const MapImpCheckSignal= () => {
  const mapProps = useMapProps({
    INITIAL_POINT_LAYER_PROPS: {

      INITIAL_GEOJSON_EXTRA_PARAMS: {
      currentDistrictCode: '',
    },
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },

      getIconWidth: (feature, zoom) => {
        let iconWidth = 18;

        if (zoom <= 13) {
          return 18;
        }else if (zoom >= 14) {
          return 24;
        } else {
          iconWidth -= iconWidth * (12 - Math.max(7, zoom)) / 14;
          return Math.min(24, iconWidth);
        }
      },
      latitudeExtractorForHeatmap: ({position}) => position[0],
      longitudeExtractorForHeatmap: ({position}) => position[1],
      intensityExtractorForHeatmap: ({iconCode}) => ({'national-blue': 500, 'national-green': 400, 'national-yellow': 300, 'national-orange': 200, 'national-red': 100}[iconCode]),
    },
    INITIAL_LAYER_WMS_TYPES: [
      // LAYER_WMS_TYPES.PARK_AREA_SHP,
      // LAYER_WMS_TYPES.GSTN_PMNTN_LN,
    ],
    INITIAL_WIDGET_STATE: {
      agency_name: 1,
      service_code: '3.5G',
      extra_search: false,
      sensitive_impcheck: ['skt', 'kt','lgt'],
    },
    INITIAL_VIEW_STATE
  });

  const {
    setMapCenter,
    setPointsResponseList,
    clickedPointIconObjects,
    widgetState,
    onChangeWidgetState,
    updateMapLayerNames,
    setMountainReceiveSensitivityLayerList,
    sensitivityLayerListWithband,
    setSensitivityLayerListWithband,
    setClickedPointIconObjects,
    isNationalParkHeapmap,
     currentDistrictCode,
    setCurrentDistrictCode,
    setPointsLayerFilterFunc,
    mapDistrictStats, setMapDistrictStats, isChangedMapDistrictStats,
    clickedPolygonGeojsonObjects,
    setGeojsonExtraParams,
    dataResponseList,
    pointsResponseList,
  } = mapProps;


  const [parkType, setParkType] = useState('국립공원');
  const [currentPark, setCurrentPark] = useState();
  const [sidoCode, setSidoCode] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [mountainReceiveSensitivityTypeList, setMountainReceiveSensitivityTypeList] = useState(['skt', 'kt','lg']);

  const [tableData, setTableData] = useState();
  const [isVisibleTable, setIsVisibleTable] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  const {agency_name, service_code, extra_search} = widgetState;





  // 산악지역 무선국 데이터의 목록보기 정렬 초기화 기능 설정
  // 컬럼 정렬 기준값을 담아둘 상탯값을 정의하고, 이를 각 컬럼의 sortOrder에 반영합니다.
  const [sortedInfo, setSortedInfo] = useState({});

  // 수신 감도 목록보기 정렬 초기화 기능 설정
  // 컬럼 정렬 기준값을 담아둘 상탯값을 정의하고, 이를 각 컬럼의 sortOrder에 반영합니다.
  const newColumnsBySensitiveData = useMemo(() => {
    if(sensitivityLayerListWithband) {
      const makedColumns = [
        {
          title: '순번',
          dataIndex: 'rownum',
          key: 'rownum',
          width: 75,
          align: 'center',
          sorter: makeTableSorterFn('rownum')
        },
        {
          title: '전파수신레벨', dataIndex: 'value', key: 'value',
          render: text => AlignRightText({text}), sorter: makeTableSorterFnNumber('value')
        },

        {
          title: '위도', dataIndex: 'lon', key: 'lon',
          render: text => AlignRightText({text}),
        },
        {
          title: '경도', dataIndex: 'lat', key: 'lat',
          render: text => AlignRightText({text}),
        },
        {
          title: '서비스 종류', dataIndex: 'type', key: 'type',
          render: text => AlignCenterText({text}), sorter: makeTableSorterFn('type')
        },


      ];
      return makedColumns.map(column => {
        const {dataIndex} = column;
        const {columnKey, order} = sortedInfo || {};
        const sortOrder = (columnKey === dataIndex) && order;
        return {
          ...column,
          sortOrder,
        }
      })
    }
  }, [sortedInfo, sensitivityLayerListWithband]);

  // 테이블의 변경정보를 관련 상탯값에 반영합니다.
  const onChangeTable = useCallback((pagination, filters, sorter) => {
    setSortedInfo(sorter);
  }, []);

//  useEffect(() => {
//    updateMapLayerNames("PARK_AREA_SHP", true);
//  }, []);
const [fillColorLegend, setFillColorLegend] = useState();

  // 공원목록에서 공원이 선택되면, 해당 위치로 지도를 이동시키고
  // 해당 공원의 무선국 목록을 읽어들여 지도에 표시합니다. - FIXME: 쿼리 응답이 느려서 페이징 처리가 필요합니다.
  const [stationListLoading, stationListResponse] = usePromise(() => {
    if (currentPark) {
      onChangeWidgetState({target: {name: 'extra_search', value: false}});
      const {name, rx, ry, lx, ly} = currentPark;

      // FIXME: viewport.fitBounds를 통해 적정 latitude/longitude/zoom 찾기
      // https://github.com/uber/deck.gl/blob/master/docs/developer-guide/views.md#viewport
      // viewport.fitBounds([...])

      const latitude = (parseFloat(ly) + parseFloat(ry)) / 2;
      const longitude = (parseFloat(lx) + parseFloat(rx)) / 2;
      const zoom = 8;



        setMapCenter({latitude, longitude, zoom});
      // 국립공원 `name`의 무선국 정보를 획득합니다.
      const pointsUrl = getApiHost() + '/gis/impcheckServiceListArw.json';
      const formData = new FormData();
      const encodeName = encodeURI(name);
      formData.append('innpk_nm', encodeName);
      if (extra_search && name !== '북한산') {
        formData.append('extra', 'Y');
      } else {
        formData.append('extra', 'N');
      }

      return Axios.post(pointsUrl, formData);
    }
  }, [currentPark, extra_search]);


  useEffect(() => {
    if (extra_search && !stationListLoading) {
      msgClose();
    }
  }, [stationListLoading]);

  useEffect(() => {
    if (stationListResponse) {
      const {data} = stationListResponse;
      const serviceCodeList = (service_code.length === 0) ? [] : service_code.split(',');
      setPointsResponseList(
        [
          data
            .filter(({CUS_NO}) => {
              return (
              agency_name.length === 0) || (CUS_NO === agency_name);
            })
            .filter(({RDS_SVC_FORM_CD}) => {
              return (serviceCodeList.length === 0) || serviceCodeList.includes(RDS_SVC_FORM_CD);
            })
            .map(item => {
              return {
                uid: item.RDS_PMS_NO,
                position: [parseFloat(item.RDS_TRS_ADR_LOU_CDN), parseFloat(item.RDS_TRS_ADR_LTD_CDN)],
                ...item,
              };
            })
        ]
      );
    }
  }, [stationListResponse, agency_name, service_code, setPointsResponseList]);

  useEffect(() => {
    if (!currentPark || mountainReceiveSensitivityTypeList.length === 0) {
      setMountainReceiveSensitivityLayerList([]);
      setSensitivityLayerListWithband([]);
    } else {
      const {name} = currentPark;



      (async function () {
        setMountainReceiveSensitivityLayerList([]);
        setSensitivityLayerListWithband([]);
        const sensitivityUrl = getApiUrl({type: "type4", parkNm: name});

        const result = await Axios.get(sensitivityUrl);
        const urlList = [result.data.data, result.data.points];
        const responseList = await Axios.all(urlList.map(url => Axios.get(getApiHost() + url)));
        const layerList = responseList.map(({data}) => data);


        // 수신감도 목록보기용 데이터 가공
        setSensitivityLayerListWithband(
            [layerList[0]].map(bandList => {
              return bandList
//                .filter(({type}) => {
//                  return mountainReceiveSensitivityTypeList.includes(type);
//                })
                .filter(({type}) => {
                  if (agency_name === 1) {
                    return '3.5g' === type;
                  } else if (agency_name === 2) {
                    return '28g' === type;
                  } else {
                    return true;
                  }
                })
                .filter(({value}) => value !== 0)

                .map((banditem, i) => {
                  const [longitude, latitude] = banditem.position;
                  const agency = banditem.agency;
                  const band = banditem.band;
                  const index = banditem.index;
                  const type = banditem.type.toUpperCase();
                  const uid = banditem.uid;
                  const value = banditem.value;
                  const rownum = i + 1;
                  const lon = degressToPosition(longitude);
                  const lat = degressToPosition(latitude);
                  const tableResult = NationalHzTable.find(({agency, type, band}) => agency === banditem.agency
                                                                                            && type === banditem.type.toUpperCase()
                                                                                            && band === banditem.band ? true : false);
                  let let_frq_hz = 0;
                  let let_band_width = 0;
                  if(tableResult !== undefined) {
                    const {frq_hz, band_width} = tableResult;
                    let_frq_hz = frq_hz;
                    let_band_width = band_width;
                  }


                  return {
                    agency,
                    band,
                    index,
                    type,
                    uid,
                    value,
                    lon,
                    lat,
                    rownum,
                    frq_hz: let_frq_hz,
                    band_width: let_band_width
                  };
                });
            })[0]
        );
        // 수신감도 아이콘 지도 위에 뿌리기 위해 가공
        setMountainReceiveSensitivityLayerList(
            [layerList[1]].map(propertiesList => {
            return propertiesList
//              .filter(({type}) => {
//                return mountainReceiveSensitivityTypeList.includes(type);
//              })
              .filter(({type}) => {
                if (agency_name === 1) {
                  return '3.5g' === type;
                } else if (agency_name === 2) {
                  return '28g' === type;

                } else {
                  return true;
                }
              })
              .map(properties => {
                const {agency, position, type} = properties;
                const [longitude, latitude] = position;

                let value = Math.abs(properties.value);
                const range = [Math.abs(-60), Math.abs(-150)];
                const iconCodeList = [
                  'national-blue',
                  'national-green',
                  'national-yellow',
                  'national-orange',
                  'national-red',
                ];
                const step = Math.abs(range[0] - range[1]) / iconCodeList.length;
                if (value < range[0]) value = range[0];
                if (value > range[1]) value = range[1];

                const index = Math.floor((Math.abs(value) - range[0]) / step);
                const iconCode = index >= 5 ? iconCodeList[4] : iconCodeList[index];

                const popupMessage =
                  <>
                    <div style={{color: '#186fc1', fontWeight: 'bold', fontSize: '14px'}}>
                     {type.toUpperCase()}
                    </div>
                    {-value}
                  </>;

                return {
                  position: [latitude, longitude],
                  iconCode,
                  popupMessage,
                };
              });
          })
        );
      })();
    }
  }, [currentPark, agency_name]);


  useEffect(() => {
    if (isVisibleTable && currentPark) {
      const {name} = currentPark;
      //updateTable({name, setTableData, setIsLoading, setError, extra_search});
    } else {
      setTableData(null);
      setError(null);
      setSortedInfo(null);
    }
  }, [isVisibleTable]);

  const onClickedPointInWidgetTable = useCallback((feature) => {
    const {latitude, longitude} = feature;
    const newLongitude = positionToDegress(longitude);
    const newLatitude = positionToDegress(latitude);
    const newFeature = {...feature, position: [newLongitude, newLatitude]};
    setClickedPointIconObjects([newFeature]);
  }, [setClickedPointIconObjects]);


 useEffect(() => {
    const [metricObject, metricMax] = mapDistrictStats;

    if (window.isFinite(metricMax) && metricMax >= 9) {
      setFillColorLegend(
        [...Array(9).keys()].map(colorIndex => {
          const boundary = (metricMax / 9) * (colorIndex + 1);
          const index = Math.floor(PALETTE_YlOrRd_9.length * (boundary - 1) / metricMax);
          const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
          return [colorRgb, boundary];
        }).reverse()
      );
    }
  }, [mapDistrictStats]);

  useEffect(() => {
    setGeojsonExtraParams(prev => ({
      ...prev,
      currentDistrictCode,
    }));
    if ((currentDistrictCode||'').length <= 2) {
      setIsVisible(false);
    }
  }, [currentDistrictCode]);



  useEffect(() => {
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {properties: {name, pk}} = firstLayer;
      setCurrentDistrictCode(pk);
      setSidoCode(pk.substr(0, 2));
      if ((pk||'').length <= 2){
        setIsVisible(false);
      }
    }
  }, [clickedPolygonGeojsonObjects]);
  const {Portal} = usePortal({
    bindTo: getLastDomByClassName('toolbar-show-list'),
  });

  const [isDownloading, setIsDownloading] = useState(false);
  const [isSensitiveDownloading, setSensitiveIsDownloading] = useState(false);

  const downloadXlsx = useCallback(() => {
    setError(null);
    setIsDownloading(true);
    const {name} = currentPark;
    const params = {
      isExcelDownload: true,
      innpk_nm: name,
      extraYn: extra_search ? 'Y' : 'N'
    };
    getListByParameters(params)
    .then(({ data }) => {
      setIsDownloading(false);
    })
    .catch(e => setError(e));
  }, [currentPark, extra_search]);


  const downloadXSensitivelsx = useCallback(() => {
    if (sensitivityLayerListWithband) {
      setError(null);
      setSensitiveIsDownloading(false);
    }
  }, [sensitivityLayerListWithband]);

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase  isHideGeolocated={true}>
        <WidgetContainer>
          <div>
             <WidgetDistrictSelect isShowDistrictLayerFromGeoserver={true} />
            <WidgetGeocoding style={{
              margin: '-10px 0px 10px 0px',
            }}/>
<WidgetImpCheck   parkType={parkType}
                                setParkType={setParkType}
                                defaultParkDict={{
                                  국립공원: "가야산",

                                }}

                                setCurrentPark={setCurrentPark}/>
           <WidgetImpCheckFilter disabled={!currentPark}  currentPark={currentPark} />
          <WidgetImpCheckSensitivity currentPark={currentPark}
                                                  setMountainReceiveSensitivityTypeList={setMountainReceiveSensitivityTypeList}/>

          </div>
        </WidgetContainer>


        <>
          <Portal>
            <Button type={isVisibleTable ? "primary" : undefined}
                    disabled={!currentPark}
                    onClick={() => setIsVisibleTable(visible => !visible)}>
              목록 보기
            </Button>
          </Portal>

          <Drawer placement={"bottom"}
                  height={300 + 180}
                  visible={isVisibleTable}
                  closable={false}
                  bodyStyle={{padding: 12}}>
            <div style={{height: '100%'}}>
              <Tabs>

                <Tabs.TabPane tab={
                  sensitivityLayerListWithband && Object.values(sensitivityLayerListWithband).length > 0
                    ? `총 전파수신레벨 수 ${sensitivityLayerListWithband.length}건`
                    : '총 수신감도 수 0건'
                }
                              key={2}>
                  {error &&
                  <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"}/>
                  }
                  {!error &&
                  <>
                    <div style={STYLE_SUBMIT}>
                      <ExportExcelButton
                        onClick={downloadXSensitivelsx}
                        style={{marginRight: 8}}
                        type="primary"
                        disabled={isSensitiveDownloading}
                        filename={'이행점검_전파수신레벨.xls'}
                        data={sensitivityLayerListWithband}
                        columns={[
                          {title: '순번', dataIndex: 'rownum', key: 'rownum', width: 75, align: 'center', sorter: makeTableSorterFn('rownum')},
                          {
                            title: '전파수신레벨', dataIndex: 'value', key: 'value',
                            render: text => AlignRightText({text}), sorter: makeTableSorterFn('value')
                          },

                          {
                            title: '위도', dataIndex: 'lon', key: 'lon',
                            render: text => AlignRightText({text}),
                          },
                          {
                            title: '경도', dataIndex: 'lat', key: 'lat',
                            render: text => AlignRightText({text}),
                          },
                          {
                            title: '측정대역', dataIndex: 'type', key: 'type',
                            render: text => AlignCenterText({text}), sorter: makeTableSorterFn('type')
                          },


                        ]}
                      >
                        {isSensitiveDownloading && <Icon type="loading"/>}
                        {!isSensitiveDownloading && <FontAwesomeIcon icon={faFileExcel}/>}
                        <span style={{marginLeft: 8}}>엑셀 내보내기</span>
                      </ExportExcelButton>
                      <Button onClick={() => setIsVisibleTable(false)}>
                        닫기
                      </Button>
                    </div>
                    <Table
                      dataSource={sensitivityLayerListWithband}
                      columns={newColumnsBySensitiveData}
                      onChange={onChangeTable}
                      size={"small"}
                      rowKey={"uid"}
                      bordered={true}
                      loading={!sensitivityLayerListWithband && !error}
                      ellipsis={true}
                      scroll={{x: 1900, y: 300}}
                      pagination={{
                        defaultPageSize: 20,
                        showSizeChanger: true,
                        pageSizeOptions: ['20', '50', '100'],
                      }}
                    />
                  </>
                  }
                </Tabs.TabPane>
              </Tabs>
            </div>
          </Drawer>
        </>

        {!isNationalParkHeapmap
            ? <WidgetLegend iconLegend={ICON_LEGEND} />
            : <WidgetLegend iconLegend={ICON_LEGEND}/>
        }
      </MapBase>
      <WidgetToolbar/>

      <LoadingIndicator visible={stationListLoading || !stationListResponse}/>
    </MapPropsProvider>
  );
};


const updateTable = ({name, setTableData, setIsLoading, setError, extra_search}) => {
  setIsLoading(true);
  const url = getApiHost() + '/gis/impcheckServiceListArw.json';
  const formData = new FormData();
  const encodeName = encodeURI(name);

  formData.append('innpk_nm', encodeName);
  if (extra_search) {
    formData.append('extra', 'Y');
  } else {
    formData.append('extra', 'N');
  }
  Axios.post(url, formData)
    .then(response => {
      const {data} = response;
      setTableData(data);
      setIsLoading(false);
    }).catch(e => {
    setError(e);
  });
};


const STYLE_SUBMIT = {
  position: 'absolute',
  top: 4,
  right: 0,
};
const NationalHzTable = [
  {band: '1', agency: 'SKT 3.5G', type: '3.5G', frq_hz: 3650, band_width: 100},
  {band: '2', agency: 'KT 3.5G', type: '3.5G', frq_hz: 3550, band_width: 100},
  {band: '3', agency: 'LGU+ 3.5G', type: '3.5G', frq_hz: 3460, band_width: 80},
 {band: '4', agency: 'SKT 28G', type: '28G', frq_hz: 28550, band_width: 800},
  {band: '5', agency: 'KT  28G', type: '28G', frq_hz: 27750, band_width: 800},
   {band: '6', agency: 'LGU+ 28G', type: '28G', frq_hz: 26950, band_width: 800},
]


export default MapImpCheckSignal;
